import React from 'react';
import Skeleton from "react-loading-skeleton";
import '../Css/homeSkeleton.css';

const HomeSkeleton = () => {
  return (
    <div className='homeSkeleton'>

      <div className='mainHomeSkeleton'>
        <div className='restaurantSkeleton'>
        
              <div className='row'>
            
                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                  <div className='cardSkeleton'>
                    <Skeleton height="150px" width="100%" />

                    <div className='row'>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                    </div>
                    <Skeleton height="30px" className='mt-2' width="100%" />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                  <div className='cardSkeleton'>
                    <Skeleton height="150px" width="100%" />

                    <div className='row'>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                    </div>
                    <Skeleton height="30px" className='mt-2' width="100%" />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                  <div className='cardSkeleton'>
                    <Skeleton height="150px" width="100%" />

                    <div className='row'>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                      <div className='col-md-6'>
                        <Skeleton height="30px" className='mt-2' width="100%" />
                      </div>
                    </div>
                    <Skeleton height="30px" className='mt-2' width="100%" />
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeSkeleton